import axios from "axios";
import store from "./../store";

// Objeto que almacenará las traducciones cargadas
const translations = {};

// Función para cargar las traducciones desde el servidor según el idioma
export async function loadTranslations(locale) {
  try {
    const response = await axios.get(`/locale/${locale}.json`);
    translations[locale] = response.data;
    return translations[locale];
  } catch (error) {
    console.error(`Error loading translations for locale ${locale}:`, error);
  }
}

export function t(key) {
  var locale = store.state.locale;
  return translations[locale][key] || ""
}
